<template>
	<div class="row margin-tb-150" dusk="failure">

		<article class="wrap--sm">

			<section class="row">

				<header class="confirm margin-b-50 center">

					<h3>Din betaling blev ikke gennemført</h3>

					<p v-html="errorMessage"></p>

				</header>

				<section class="row margin-b-50 center">

					<router-link class="btn--primary" :to="{name:'order.approve'}">Gå tilbage</router-link>

				</section>

			</section>

		</article>

	</div>
</template>

<script>
	import {mapGetters} from 'vuex';
    export default {
        name: "failedOrder",
        data() {
            return {
                translatedMessages:{
                    invalid_number: `Kortnummeret er ugyldigt </br>
                    <strong>OBS! Vi modtager IKKE alm. Dankort i shoppen.</strong>
                    `,
                    invalid_expiry_month:'Kortets udløbsmåned er ugyldigt.',
                    invalid_expiry_year:'Kortets udløbsår er ugyldigt.',
                    invalid_cvc:'Kortets CVC sikkerhedskode er ugyldig.',
                    incorrect_number:`Kortnummeret er ikke korrekt.</br>
                    <strong>OBS! Vi modtager IKKE alm. Dankort i shoppen.</strong>
                    `,
                    expired_card:'Kortet er udløbet.',
                    incorrect_cvc:'Kortets CVC sikkerhedskode er ikke korrekt.',
                    incorrect_zip:'Kortets postnummer kan ikke valideres.',
                    card_declined:`Kortet blev afvist. </br>
                    <strong>OBS! Vi modtager IKKE alm. Dankort i shoppen.</strong>
                    `,
                    missing:'Dette kort er ikke tilknyttet en kunde.',
                    processing_error:'Fejl under transaktion.'
                }
            }
        },
        computed:{
            ...mapGetters({
                cardError:'cardError'
            }),
            errorMessage(){
                if(!this.cardError)
                {
                    return 'Der skete en fejl under behandlingen af betalingen, prøv venligst igen.';
                }
                return this.translatedMessages[this.cardError];
            }
        },
    }
</script>

<style scoped>

</style>
